import {Component, Input} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IonicModule} from "@ionic/angular";
import {Router} from '@angular/router';
import {AuthService, KioskService, StorageService} from "src/app/services";

@Component({
  selector: 'app-sign-in-out',
  templateUrl: './sign-in-out.component.html',
  styleUrls: ['./sign-in-out.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule],
})
export class SignInOutComponent {
  @Input() parent: 'menu' | 'home' = 'menu';
  private prompt = false;

  constructor(
    private readonly router: Router,
    private readonly auth: AuthService,
    private readonly kiosk: KioskService,
    private readonly storage: StorageService,
  ) {
  }

  // for the template and the function below
  get isSignedIn(): boolean {
    return this.auth.isSignedIn$.value;
  }

  get showItem(): boolean {
    if (this.parent === 'home') {
      return this.storage.isKioskMode$.value || this.auth.isSignedOut$.value;
    }
    return true;
  }

  get showToggle(): boolean {
    return this.parent === 'menu' && this.storage.isAppMode$.value && this.auth.isSignedOut$.value;
  }

  togglePrompt(event: Event): void {
    event.stopPropagation();
    this.prompt = !this.prompt;
  }

  onSignInOut(): void {
    const isSignedIn = this.isSignedIn;
    if (this.storage.isAppMode$.value) {
      if (isSignedIn) {
        this.auth.signOut();
      } else {
        this.auth.signIn(this.prompt);
      }
    } else {
      if (isSignedIn) {
        this.kiosk.signOut();
      } else {
        this.router.navigate(['/switch-user']).then();
      }
    }
  }
}
